export const pageNames = {
    RELEASE_LINES: 'Release Lines',
    FORMS: 'Forms',
    PHYSICAL: 'Physical',
    PHYSICAL_CAMERA: 'Physical Camera',
    TRACE: 'Trace',
};

export const releaseLineStatuses = {
    PICKED: 'Picked',
    PENDING_SALES: 'Pending Sales',
    IN_QC: 'In QC',
};

export const keywordListToCheckAgainst = [
    '0ring',
    '0rings',
    'oring',
    'orings',
    'packing',
    'packings',
    'gasket',
    'gaskets',
    'bearing',
    'bearings',
    'seal',
    'seals',
    'fitting',
    'fittings',
    'label',
    'labels',
    'placard',
    'placards',
    'power unit',
    'battery',
    'marker',
    'markers',
];

export const submissionStatuses = {
    WAITING: 'Waiting',
    LOADING: 'Loading',
    SUBMITTED: 'Submitted',
    ERROR: 'Error',
};

export const physicalInspectionStatuses = {
    INSPECTION_PASSED: 'INSPECTION_PASSED',
    INSPECTION_PARTIAL_PASSED: 'INSPECTION_PARTIAL_PASSED',
    INSPECTION_REJECTED: 'INSPECTION_REJECTED',
    INSPECTION_COMPLETED: 'INSPECTION_COMPLETED',
};

export const physicalInspectionCriteria = {
    QUANTITY: 'quantity',
    EXPIRATION_DATE: 'expirationDate',
    SPECIAL_KEYWORD: 'specialKeyword',
    PART_NUMBER: 'partNumber',
    SERIAL_NUMBER: 'serialNumber',
    NO_SHELF_LIFE: 'noShelfLife',
};

export const stepConfirmationStatuses = {
    SUCCESS: 'success',
    PENDING: 'pending',
    FAIL: 'fail',
};

export const buttonLoadingTitles = {
    INSPECTION_PASSED: 'passed',
    INSPECTION_REJECTED: 'rejected',
    PHOTOS_ACCEPTED_RETURN: 'accepted-return',
    PHOTOS_ACCEPTED_TRACE: 'accepted-trace',
};
